import React, { useEffect, useState } from "react";

import "./filterBetry.css";

import { client } from "./Socket";
// import LoadingScreen from "./LoadingScreen";
import axios from "axios";

export const sendData = (topic, value) => {
  client.publish(topic, value);
  console.log("publish", topic, value);
};

export const getDateTimeUsingLocation = async (
  latitude,
  longitude,
  utcTimeString
) => {
  // Convert DD/MM/YYYY format to YYYY-MM-DD
  console.log("utcTimeString", utcTimeString);
  console.log("formattedUTCString", new Date(utcTimeString));

  // Get timezone from coordinates using Google Time Zone API
  const timestamp = Math.floor(new Date(utcTimeString).getTime() / 1000);
  if (isNaN(timestamp)) {
    return;
  }
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude},${longitude}&timestamp=${timestamp}&key=AIzaSyBajhVyi8KbuKuEPk1osx9M_7qmpg8e1-c`
  );
  const timezoneData = await response.json();

  const utcDate = new Date(utcTimeString);
  // Apply the timezone offset
  const localTime = new Date(utcDate.getTime() + timezoneData.rawOffset * 1000);
  console.log(
    "Time Zone output",
    localTime,
    timestamp,
    latitude,
    longitude,
    utcTimeString
  );

  return localTime.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

export default function FilterSubCom({ locationData, setEnabled }) {
  let configuration_list = [
    "current",
    "time_left",
    "time_on",
    "system_led",
    "filter_led",
    "water_led",
    "blocked_led",
    "system_id",
    "schedule_id",
    "percentage",
    "name",
    "high_thesold",
    "low_thesold",
    "timestamp",
    "filter",
    "enabled",
    "offset",
    "heartbeat",
  ];

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [InstallationTime, setInstallationTime] = useState("");

  useEffect(() => {
    // console.log()
    (async () => {
      const time = await getDateTimeUsingLocation(
        latitude,
        longitude,
        InstallationTime
      );
      console.log("TIME OUTPUT", time, InstallationTime, latitude, longitude);
      if (time !== undefined) {
        // alert(time);
      }
    })();
  }, [latitude, longitude, InstallationTime]);

  useEffect(() => {
    if (locationData) {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: "https://api.db2sg.com/esps",
        headers: {},
      };
      axios
        .request(config)
        .then(async (response) => {
          let resData = response.data;
          if (resData.data) {
            let proData = resData?.data.filter(
              (el) => el.id === locationData.esp_id
            );

            setLatitude(proData[0].latitude);
            setLongitude(proData[0].longitude);

            setInstallationTime(proData[0].installation_date);

            proData[0]["enabled"] = locationData.user.devices[
              locationData.esp_id
            ].enabled
              ? 1
              : 0;
            let tempArr = configuration_list.map((el) => {
              return proData[0].id + "/" + el;
            });
            client.subscribe(tempArr, (err) => {
              if (!err) {
              } else {
                // console.log(err);
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });

      client.on("message", (topic, message) => {
        // message is Buffer

        if (topic === `${locationData.esp_id}/enabled`) {
          (async () => {
            await axios.get(
              `https://api.db2sg.com/users/${locationData.user.id}/${
                locationData.esp_id
              }/${message.toString() === "1"}`
            );
          })();
        }
        console.log(topic);
        console.log(message.toString());
        // client.end();
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    (async () => {
      if (latitude && longitude) {
        sendData(`${locationData.esp_id}/latitude`, `${latitude}`);
        sendData(`${locationData.esp_id}/longitude`, `${longitude}`);
      }
    })();
  }, [latitude, locationData.esp_id, longitude]);

  useEffect(() => {
    (async () => {
      if (InstallationTime === "Invalid Date") {
        alert("Tried setting Invalid Date");
        return;
      }
    })();
    // eslint-disable-next-line
  }, [InstallationTime, locationData.esp_id]);

  return <div></div>;
}
